<template>
    <ul class="flex flex-col">
        <li v-for="moment in moments" :key="moment.id" class="row-item">
            <button
                type="button"
                class="group flex w-full items-center gap-3 px-2.5 py-4 text-start disabled:cursor-default disabled:opacity-60"
                :disabled="moment.state === 'locked'"
                :data-testid="`picker-moment-${moment.id}`"
                @click="emit('select', moment.id)">
                <span class="grow min-w-0 body-small text-ink truncate">{{ moment.title }}</span>
                <span v-if="stateNote(moment)" class="shrink-0 scaffold-details-small text-ink-muted">{{ stateNote(moment) }}</span>
                <!-- Hidden rather than removed on unpickable rows, so every row's note ends at the same edge. -->
                <i
                    class="bi bi-chevron-right shrink-0 text-xs/none text-ink-muted transition-colors group-hover:text-ink"
                    :class="{ invisible: moment.state === 'locked' }"
                    aria-hidden="true"></i>
            </button>
        </li>
        <li class="row-item">
            <button type="button" class="flex w-full items-center gap-3 px-2.5 py-4 text-start" data-testid="picker-moment-something-else" @click="emit('dismiss')">
                <i class="bi bi-pencil shrink-0 text-base/none text-ink-muted" aria-hidden="true"></i>
                <span class="body-small text-ink-muted">{{ t("chat.pmPicker.somethingElse") }}</span>
            </button>
        </li>
    </ul>
</template>

<script setup lang="ts">
import type { PerformanceMomentSummary } from "~vue/types/performance_management";
import { useI18n } from "vue-i18n";

defineProps<{ moments: PerformanceMomentSummary[] }>();
const { t } = useI18n();

const emit = defineEmits<{ select: [momentId: number]; dismiss: [] }>();

// Closed and not-yet-open moments say so next to the chevron.
const stateNote = (moment: PerformanceMomentSummary): string | null => {
    if (moment.state === "locked") {
        return t("chat.pmPicker.momentStatus.comingSoon");
    }
    return moment.state === "expired" ? t("chat.pmPicker.momentStatus.expired") : null;
};
</script>

<style scoped>
@reference "../../../../css/tailwind.css";

@layer components {
    .row-item {
        @apply border-b border-border;
    }

    .row-item:last-child {
        @apply border-b-0;
    }
}
</style>
